var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isDevEnv()
        ? _c(
            "div",
            {
              staticClass: "text-center fs-26 text-black",
              staticStyle: { "background-color": "#f8c8c3", padding: "0 5px" },
            },
            [
              _c(
                "b-container",
                { staticClass: "d-flex justify-content-between" },
                [
                  _c("strong", [
                    _vm._v(
                      "ВНИМАНИЕ!!! Это тестовая площадка " +
                        _vm._s(
                          _vm.theme.variables.view.application_name_short
                        ) +
                        ". Основной адрес " +
                        _vm._s(
                          _vm.theme.variables.view.application_name_short
                        ) +
                        " - "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "link-black",
                        attrs: {
                          href: _vm.theme.variables.view.production_url,
                        },
                      },
                      [_vm._v(_vm._s(_vm.theme.variables.view.production_url))]
                    ),
                  ]),
                  _c("span", { staticClass: "text-black fs-12" }, [
                    _vm._v("v" + _vm._s(_vm.theme.version.full)),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-container",
        { staticClass: "top_info-line", attrs: { fluid: "" } },
        [
          _c(
            "b-container",
            { staticStyle: { "max-height": "100px" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "w-100",
                        staticStyle: {
                          height: "36px",
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center w-100 align-items-center",
                          },
                          [
                            _c("div", { staticClass: "d-flex times" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "today",
                                  staticStyle: { "margin-right": "42px" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "grey-color fs-12" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.localDate) +
                                          " (" +
                                          _vm._s(_vm.weekday) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "local_time mr-4" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "clock",
                                    src: "/images/clock.svg",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "ml-2 grey-color fs-12" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.theme.variables.view.city) +
                                        " — " +
                                        _vm._s(_vm.localTime)
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "moscow_time ml-1" }, [
                                _c("img", {
                                  attrs: {
                                    alt: "clock",
                                    src: "/images/clock.svg",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "ml-2 grey-color fs-12" },
                                  [_vm._v("Москва — " + _vm._s(_vm.moscowTime))]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex ml-auto center-768 my-auto align-items-center",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "atmo-override-link-off grey-color fs-12 fw-600 text-nowrap cursor-pointer ml-3",
                                    attrs: {
                                      href: _vm.$links.legal_documents,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("ПРАВОВЫЕ ДОКУМЕНТЫ")]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "atmo-override-link-off grey-color fs-12 fw-600 text-nowrap cursor-pointer ml-3",
                                    attrs: {
                                      href: _vm.$links.info_materials,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("ИНФОРМАЦИОННЫЕ МАТЕРИАЛЫ")]
                                ),
                                _vm.windowWidth >= 768
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btn btn-card-action btn-card-action-green ml-3 font-weight-bold",
                                        staticStyle: {
                                          width: "auto !important",
                                          "padding-top": "4px !important",
                                          "padding-bottom": "4px !important",
                                        },
                                        attrs: {
                                          href: "https://courses.plschool.ru/",
                                          size: "sm",
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v("ОБУЧАЮЩИЙ КУРС")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "nav_line", attrs: { fluid: "" } },
        [
          _c(
            "b-container",
            { staticClass: "py-2" },
            [
              _c(
                "b-row",
                { staticClass: "d-flex flex-nowrap" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "router-link",
                        {
                          staticStyle: { border: "none !important" },
                          attrs: { to: "/" },
                        },
                        [_c("ThemeLogo")],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "ml-auto", attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "h-100 fast_links" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center desktop_link right_line",
                            },
                            [
                              _c(
                                "a",
                                { attrs: { href: "#" } },
                                [
                                  _c(
                                    "b-dropdown",
                                    {
                                      attrs: {
                                        variant: "link",
                                        "toggle-class":
                                          "text-decoration-none mx-0 px-0 fs-14 font-weight-bold",
                                        "no-caret": "",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "grey-color" },
                                                [_vm._v("44-ФЗ")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Fl44NoticesList",
                                              params: { status: "accepting" },
                                            },
                                            "link-class": "fs-14 grey-color",
                                          },
                                        },
                                        [_vm._v("Извещения")]
                                      ),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            "link-class":
                                              _vm.$route.matched[0]?.path ===
                                              "/contracts/fl44"
                                                ? "fs-14 grey-color router-link-active"
                                                : "fs-14 grey-color",
                                            to: {
                                              name: "ContractsList",
                                              params: { contract: "all" },
                                            },
                                          },
                                        },
                                        [_vm._v("Контракты")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center desktop_link right_line",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-nowrap",
                                  class:
                                    _vm.$route.matched[0]?.path ===
                                      "/notices/fl223" && "router-link-active",
                                  attrs: {
                                    to: {
                                      name: "Fl223NoticesList",
                                      params: { status: "accepting" },
                                    },
                                  },
                                },
                                [_vm._v("223-ФЗ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center desktop_link right_line",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-nowrap",
                                  class:
                                    _vm.$route.matched[0]?.path ===
                                      "/notices/commercial" &&
                                    "router-link-active",
                                  attrs: {
                                    to: {
                                      name: "CommercialNoticesList",
                                      params: { status: "accepting" },
                                    },
                                  },
                                },
                                [_vm._v("КОММЕРЧЕСКИЕ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center desktop_link right_line",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-nowrap",
                                  attrs: { to: "/quotation-requests" },
                                },
                                [_vm._v("ЗАПРОСЫ КП")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-items-center desktop_link text-nowrap",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    href: _vm.$links.telegram_channel,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v("Новости "),
                                  _c("b-icon", {
                                    staticStyle: { color: "#229ed9" },
                                    attrs: { icon: "telegram" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "cursor-pointer grey-color my-auto",
                                  class: {
                                    "fas fa-times": _vm.menuVisible,
                                    "fas fa-bars": !_vm.menuVisible,
                                  },
                                  staticStyle: { width: "15px" },
                                  attrs: { "aria-controls": "full-menu" },
                                  on: {
                                    click: function ($event) {
                                      _vm.menuVisible = !_vm.menuVisible
                                    },
                                  },
                                },
                                [_c("span"), _c("span"), _c("span")]
                              ),
                            ]
                          ),
                          _vm.$store.state.token
                            ? _c("navbar-notifications-dropdown")
                            : _vm._e(),
                          _c("NavbarUserMenu", {
                            on: {
                              login: _vm.showLoginModal,
                              logout: _vm.logout,
                              register: _vm.showRegistrationModal,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Login", {
        attrs: { "show-modal": _vm.visibleLoginModal },
        on: { close: _vm.onCloseLoginModal },
      }),
      _c(
        "b-collapse",
        {
          staticClass: "full-screen",
          attrs: { id: "full-menu" },
          model: {
            value: _vm.menuVisible,
            callback: function ($$v) {
              _vm.menuVisible = $$v
            },
            expression: "menuVisible",
          },
        },
        [
          _c(
            "div",
            [
              _vm.windowWidth >= 768
                ? _c(
                    "b-container",
                    { staticClass: "top_info-line py-4", attrs: { fluid: "" } },
                    [
                      _c("full-menu", {
                        on: {
                          "hide-menu": function ($event) {
                            _vm.menuVisible = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.windowWidth < 768
                ? _c(
                    "b-container",
                    { staticClass: "top_info-line py-4", attrs: { fluid: "" } },
                    [
                      _c("mobile-menu", {
                        on: {
                          "hide-menu": function ($event) {
                            _vm.menuVisible = false
                          },
                          "show-modal": function ($event) {
                            _vm.visibleRegistrationModal = true
                          },
                          gotologin: _vm.showLoginModal,
                          logout: _vm.logout,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.menuVisible
        ? _c("div", {
            staticClass: "backdrop",
            on: { click: _vm.toggleFullMenu },
          })
        : _vm._e(),
      _c("RegisterModal", {
        on: { close: _vm.hideRegistrationModal },
        model: {
          value: _vm.visibleRegistrationModal,
          callback: function ($$v) {
            _vm.visibleRegistrationModal = $$v
          },
          expression: "visibleRegistrationModal",
        },
      }),
      _vm.visibleVerificationEmailModal
        ? [
            _c("VerificationEmailModal", {
              attrs: {
                email: _vm.userEmail,
                visible: _vm.visibleVerificationEmailModal,
              },
              on: { hidden: _vm.hideVerificationModal },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }